import useScrollAnimation from './useScrollAnimation'
import { Container, Grid, Box, Typography } from '@mui/material'

const SimplifyPlanning = () => {
  useScrollAnimation('.project-insights')

  return (
    <section id="project-insights" className="simplify-planning position-relative pad-60">
      <Container className="container position-relative">
        <Grid container alignItems="center" className="tbl-sec">
          {/* Left Side Content */}
          <Grid item lg={5} md={5} sm={12} xs={12} className=" mt-3">
            <Typography variant="h2" className="mb-4 main_titel">
              Gain Real-Time Insights with<span> Customizable Dashboards​</span>
            </Typography>

            <Box className=" mb-3">
              <Typography variant="body1">
                With Epoch7, effortlessly analyse key metrics and track performance through fully
                customizable dashboards.
              </Typography>
            </Box>
            <Box className=" mb-3">
              <Typography variant="body1">
                Adaptable visualizations ensure the right data is always at your fingertips,
                empowering you to make confident, informed decisions.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>

      {/* Right Side Image */}
      <Box className="right-image">
        <Box
          component="img"
          src="/assets/document-templates/dashboard.svg"
          alt="Material Planning"
          className="img-fluid"
        />
      </Box>
    </section>
  )
}

export default SimplifyPlanning
